const marker = document.querySelector(".scroll-lock-marker");
const stickyContent = document.querySelector(".scroll-lock__sticky-content");
const ProductInfoContainer = document.querySelector('.product__info-wrapper.grid__item');

// The marker is from the container above the scroll lock block
// We modify the position of the sticky content to be relative to the marker as if it was below the marker
// and it's sticky till the top of this scroll lock block
if (marker && stickyContent) {
  let parentHeight, contentWidth, isDesktop, markerRect, stickyContentRect, markerTop, stickyContentTop, rightPosition = 0;
  const config = () => {
    // Reset the styles
    stickyContent.style.removeProperty("position");
    stickyContent.style.removeProperty("right");
    stickyContent.style.removeProperty("top");
    stickyContent.style.removeProperty("width");
    stickyContent.parentElement.style.removeProperty("height");

    isDesktop = window.matchMedia("(min-width: 990px)").matches;
    markerRect = marker.getBoundingClientRect();
    stickyContentRect = stickyContent.getBoundingClientRect();
    markerTop = markerRect.top + window.scrollY - 40;
    stickyContentTop = stickyContentRect.top + window.scrollY;
    contentWidth = stickyContentRect.width;
    parentHeight = stickyContent.parentElement.offsetHeight; 
    rightPosition = window.innerWidth - (stickyContent.closest(".page-width").getBoundingClientRect().right);
  };

  const updateStickyContentPosition = () => {
    if (!isDesktop) {
      stickyContent.style.position = "static";
      return;
    }
    requestAnimationFrame(() => {
      const scrollY = window.scrollY;

      if (scrollY < stickyContentTop) {
        stickyContent.style.position = "absolute";
        // stickyContent.style.right = rightPosition + "px";
        stickyContent.style.right = ProductInfoContainer.getBoundingClientRect().right+ "px";
        stickyContent.style.left = ProductInfoContainer.getBoundingClientRect().left+ "px";
        if (scrollY < markerTop) {
          stickyContent.style.top = markerTop + "px";
        } else {
          stickyContent.style.top = scrollY + "px";
        }
        stickyContent.style.width = contentWidth + "px";
        stickyContent.parentElement.style.height = parentHeight + "px";
      } 
    });
  };

  window.addEventListener("DOMContentLoaded", () => {
    config();
    updateStickyContentPosition();
  });

  window.addEventListener("scroll", updateStickyContentPosition);
  window.addEventListener("resize", () => {
    config();
    if (!isDesktop) {
      stickyContent.style.position = "static";
      stickyContent.parentElement.style.height = "auto";
    }
    updateStickyContentPosition();
  });
}
